// VueEvent asking the open contact's phone list and HubSpot card to reload.
export const CONTACT_PHONE_NUMBERS_CHANGED_EVENT = 'contact_phone_numbers_changed'
